import {copyText} from '@github-ui/copy-to-clipboard'
import {CommandActionListItem, ScopedCommands} from '@github-ui/ui-commands'
import {KebabHorizontalIcon, LinkIcon, PencilIcon, QuoteIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu, IconButton} from '@primer/react'

interface ConversationItemActions {
  onQuoteReply?: () => void
  link: string
  onEdit?: () => void
}

export function ConversationItemActions({onQuoteReply, link, onEdit}: ConversationItemActions) {
  return (
    <ActionMenu>
      <ActionMenu.Anchor>
        <IconButton icon={KebabHorizontalIcon} variant="invisible" size="small" aria-label="More actions" />
      </ActionMenu.Anchor>

      <ActionMenu.Overlay align="end">
        <ActionList>
          {onQuoteReply && (
            <CommandActionListItem
              commandId="pull-requests:quote-reply"
              onSelect={onQuoteReply}
              leadingVisual={<QuoteIcon />}
            >
              Quote reply
            </CommandActionListItem>
          )}

          <ActionList.Item onSelect={() => copyText(link)}>
            <ActionList.LeadingVisual>
              <LinkIcon />
            </ActionList.LeadingVisual>
            Copy link
          </ActionList.Item>

          {onEdit && (
            <ActionList.Item onSelect={onEdit}>
              <ActionList.LeadingVisual>
                <PencilIcon />
              </ActionList.LeadingVisual>
              Edit
            </ActionList.Item>
          )}
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}

export function ConversationItemActionsProvider({
  onQuoteReply,
  children,
}: React.PropsWithChildren<Pick<ConversationItemActions, 'onQuoteReply'>>) {
  return <ScopedCommands commands={{'pull-requests:quote-reply': onQuoteReply}}>{children}</ScopedCommands>
}
